module.exports = __webpack_public_path__ + "img/expovina-primavera_04(1).41cb9b54.jpg";